import { Controller, useFormContext } from 'react-hook-form';
import type { LanguageSelectAltProps } from './LanguageSelectAlt';
import { LanguageSelectAlt } from './LanguageSelectAlt';

type LanguageFieldProps = Omit<
  LanguageSelectAltProps,
  'value' | 'onChange' | 'onBlur' | 'error' | 'disabled'
> & {
  readonly name: string;
  readonly required?: boolean;
  readonly allowEmpty?: boolean;
};

export function LanguageField(props: LanguageFieldProps) {
  const { name, ...rest } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <LanguageSelectAlt
          value={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          disabled={field.disabled}
          error={fieldState.error?.message}
          {...rest}
        />
      )}
    />
  );
}
